import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { useHotKeys } from '../../../hooks/useHotKeys';

import SystemErrorMessageForAll from './fragments/systemErrorMessageForAll';
import SystemErrorMessageForDevEnv from './fragments/systemErrorMessageForDevEnv';

import { configs } from '../../../constants/configs/configs';
import { SYSTEM_ERROR_MESSAGE_SHORTCUT_CODES } from '../../../constants/common/shortcutKeys';

const SystemErrorMessage = ({
    children,
    data,
    environment: {
        links: {
            LOGIN: login
        },
        stateCode,
        devEnvironment
    },
    error: {
        errorStatus,
        //errorMessage,
        errorType,
        time,
        code,
        endpoint
    }
}) => {

    const state = stateCode.toLowerCase();
    const errorImage = configs.ENV.DEVELOPMENT ? `../../../assets/images/${state}-error-illustration.png` : configs.endpoints.IMAGES.processReplacements({ relativePath: '/resources/img', fileName: `${state}-error-illustration.png` });

    const url = window.location.href;

    const isSystemErrorShown = useHotKeys( SYSTEM_ERROR_MESSAGE_SHORTCUT_CODES );

    return (
        <Fragment>
            { errorStatus &&
                <main className="usa-layout-docs usa-section gi-main-section" id="gi-fallback__container">
                    <SystemErrorMessageForAll { ...{ errorImage, login }} />
                    { devEnvironment && isSystemErrorShown &&
                        <SystemErrorMessageForDevEnv { ...{ errorStatus, errorType, time, code, endpoint, data, url } } />
                    }
                </main>
            }
            { !errorStatus &&
                children
            }
        </Fragment>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,
    environment: state.common.environment,
    error: state.common.error
});

export default connect(mapStateToProps)(SystemErrorMessage);